import { createActionTypes } from "@helpers/redux-helpers";

export const getProposalUsersActionTypes =
  createActionTypes("proposal/users/get");

export const getMoreProposalUsersActionTypes = createActionTypes(
  "proposal/users/getMore",
);

export const setProposalUsersActionType = "proposal/users/set";

export const createProposalActionTypes = createActionTypes("proposal/create");

export const addPendingProposalTypes = createActionTypes("proposal/addPending");

export const removePendingProposalTypes = createActionTypes(
  "proposal/removePending",
);

export const editProposalActionTypes = createActionTypes("proposal/edit");

export const getProposalDetailsActionTypes = createActionTypes(
  "proposal/getDetails",
);

export const clearIsJustCreatedActionTypes = createActionTypes(
  "proposal/isJustCreated/clear",
);
